import style from "./app-store.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'
import Slider from "../slider/slider";


const AppStore = ({appstore}: any) => {

    return (
        <SharedAnimation render={(ref) => (
            <section className={`${style.section} ${style.section__appstore}`}>
            <InView triggerOnce={true}>
                {({inView, ref, entry}) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <div ref={ref} className={`${style.appstore__title} ${animations.scroll__animation}`}>
                            {appstore.title}
                        </div>
                    )
                }}
            </InView>
            <InView triggerOnce={true}>
                {({inView, ref, entry}) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <div ref={ref} className={`${style.appstore__button} ${animations.scroll__animation}`}>
                            <a target="_blank" href="https://apps.apple.com/us/app/givingli-gifts-personalized/id1386635163?ls=1" rel="noreferrer">
                                <Image alt="appstore-button" src={appstore.image} layout={'fill'}
                                       sizes="100px"/>
                            </a>
                        </div>
                    )
                }}
            </InView>
            <InView triggerOnce={true}>
                {({inView, ref, entry}) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <>
                            <div className={`${style.elements__info__seven} `}>
                                <Image alt="element" src={"/givingli-images/elements/element-6.png"} layout={"fill"} />
                            </div>
                            <div ref={ref} className={`${style.appstore__slider} ${animations.scroll__animation}`}>
                                <Slider />
                            </div>
                        </>
                    )
                }}
            </InView>
        </section>
        )}/>
    );
}

export default AppStore;